<template>
  <div class="excellent_box" v-if="visible">
    <div class="excellent_main import-dialog-main">
      <div class="excellent_top">
        Excel 批量关联寄售单
        <i class="el-icon-close" @click.stop="close"></i>
      </div>
      <div class="excellent_content import-dialog-content">
        <div class="import-actions flex">
          <div class="import-btn">
            <el-button size="medium" type="primary" @click="triggerFileSelect">选择文件</el-button>
            <input
              ref="fileInput"
              type="file"
              accept=".xlsx,.xls"
              style="display: none"
              @change="onFileSelected"
            />
          </div>
          <div class="file-name-wrap">
            <span v-if="fileName" class="file-name">{{ fileName }}</span>
          </div>
        </div>
        <div class="import-tip">
          列：闲置商品ID、寄售订单号（商品ID与导入序号二选一填商品；订单号必填）。<br />
          闲鱼导入可填「闲置商品ID + 寄售订单号」。
        </div>
      </div>
      <div class="excellent_btn flex">
        <el-button size="medium" type="info" @click="downloadTemplate" style="margin-right: 40px">下载模板</el-button>
        <el-button size="medium" type="success" :loading="loading" :disabled="!file" @click="submit">上传</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConsignOrderLinkImportModal",
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      file: null,
      fileName: "",
      loading: false,
    };
  },
  watch: {
    visible(val) {
      if (val) this.reset();
    },
  },
  methods: {
    reset() {
      this.file = null;
      this.fileName = "";
      this.loading = false;
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },
    close() {
      this.$emit("close");
    },
    triggerFileSelect() {
      this.$refs.fileInput.click();
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      const name = file.name;
      if (!name.endsWith(".xlsx") && !name.endsWith(".xls")) {
        this.$message.error("请选择 .xlsx 或 .xls 格式的 Excel 文件");
        return;
      }
      this.file = file;
      this.fileName = name;
    },
    downloadTemplate() {
      this.$https(this.$api.api.downloadConsignOrderLinkTemplate, {}, "FILE")
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "官方寄售关联模板.xlsx";
          link.click();
          window.URL.revokeObjectURL(url);
          this.$message.success("模板下载成功");
        })
        .catch(() => this.$message.error("模板下载失败"));
    },
    submit() {
      if (!this.file) {
        this.$message.error("请选择要上传的文件");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", this.file);
      this.$https(this.$api.api.uploadConsignOrderLinkImport, formData, "POST", {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            const data = res.data.data || {};
            const fail = data.failed || 0;
            if (fail > 0) {
              this.$message.warning(res.data.msg || "部分行失败，请查看返回明细");
            } else {
              this.$message.success(res.data.msg || "导入成功");
              this.$emit("success");
              this.close();
            }
          } else {
            this.$message.error(res.data.msg || "上传失败");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("上传失败：" + (err.message || "网络错误"));
        });
    },
  },
};
</script>

<style lang="less" scoped>
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  .excellent_main {
    width: 520px;
    height: 300px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;
    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;
      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .excellent_btn {
      justify-content: center;
      margin: 25px 15px 0 0;
    }
  }
}
.import-dialog-content {
  padding: 20px;
  .import-actions {
    align-items: center;
    margin-bottom: 15px;
    .file-name-wrap {
      margin-left: 10px;
      flex: 1;
      min-width: 0;
    }
    .file-name {
      color: #409eff;
      font-size: 14px;
    }
  }
  .import-tip {
    color: #999;
    font-size: 12px;
    line-height: 1.55;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/secondhandProduct/consignOrderLinkImportModal.vue